'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { cn } from '@eliadmin/core/src/utils/style-utils';

import { Swiper, SwiperSlide } from 'swiper/react';

import { Pagination } from 'swiper/modules';
import { Reference } from '@eliadmin/core/src/api/references/references-types';
import { useRouter } from 'next/navigation';

import 'swiper/css';
import 'swiper/css/pagination';

export const FooterReferences = ({ references }: { references: Reference[] }) => {
  const router = useRouter();

  return (
    <>
      <Swiper
        slidesPerView={'auto'}
        spaceBetween={30}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination]}
        className={cn('mySwiper', 'ea-footer-reference__swiper')}
      >
        {references?.map(reference => (
          <SwiperSlide
            onClick={() => router.push(`/referencie/${reference?.slug}`)}
            className={cn('', 'ea-footer-references__slide')}
            key={reference?.slug}
          >
            <div className={cn('', 'ea-footer-references__slide-image')}>
              <Image
                src={reference?.image?.url}
                alt={resolveImageAlt(reference?.image, reference?.name)}
                fill
                style={{ objectFit: 'cover', objectPosition: 'center' }}
              />
            </div>
            <p className={cn('', 'ea-footer-references__slide-name')}>{reference?.name}</p>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className={cn('', 'ea-footer-references__wrapper')}>
        {references?.map(reference => (
          <div
            onClick={() => router.push(`/referencie/${reference?.slug}`)}
            className={cn('', 'ea-footer-references__card')}
            key={reference?.slug}
          >
            <div className={cn('', 'ea-footer-references__card-image')}>
              <Image
                src={reference?.image?.url}
                alt={resolveImageAlt(reference?.image, reference?.name)}
                fill
                style={{ objectFit: 'cover', objectPosition: 'center' }}
              />
            </div>
            <p className={cn('', 'ea-footer-references__card-name')}>{reference?.name}</p>
          </div>
        ))}
      </div>
    </>
  );
};
